import Button from "../../../components/form/button";
import Container from "../../../components/Container";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { IRecipeRecord } from "../../../lib/types";
import pb from "../../../lib/pocketbase";
import Card from "../../../components/Card";
import { config } from "../../../config";
export default function Cookbook() {
    const [loading, setLoading] = useState(true);
    const [recipes, setRecipes] = useState<IRecipeRecord[]>();

    async function load() {
        const records: IRecipeRecord[] = await pb.collection("recipe").getFullList({
            sort: "created"
        });

        setRecipes(records);
        setLoading(false);
    }

    useEffect(() => {
        load();
    }, []);
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Cookbook</title>
            </Helmet>
            <Container className="mt-4 @container md:mt-8 lg:mt-16">
                <div className="flex items-center justify-between">
                    <h2 className="text-3xl font-bold">Cookbook.</h2>
                    <Link to="new">
                        <Button size={"small"}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                            </svg>
                            New recipe
                        </Button>
                    </Link>
                </div>
                <div className="mt-8 grid grid-cols-1 gap-4 @lg:grid-cols-2 @4xl:grid-cols-3">
                    {recipes?.map((recipe) => (
                        <Card link={"/studio/cookbook/recipe/" + recipe.id} title={recipe.title} image={config.pocketbase + "/api/files/" + recipe.collectionId + "/" + recipe.id + "/" + recipe.image}></Card>
                    ))}
                </div>
            </Container>
        </>
    );
}
